
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CraneInstallationPage = lazy(() => import('../pages/services/crane-installation/page'));
const CraneMaintenancePage = lazy(() => import('../pages/services/crane-maintenance/page'));
const CraneRepairPage = lazy(() => import('../pages/services/crane-repair/page'));
const CraneModernizationPage = lazy(() => import('../pages/services/crane-modernization/page'));
const ProductionPage = lazy(() => import('../pages/production/page'));
const CraneRunwayPage = lazy(() => import('../pages/production/crane-runway/page'));
const CraneOverpassPage = lazy(() => import('../pages/production/crane-overpass/page'));
const MetalStructuresPage = lazy(() => import('../pages/production/metal-structures/page'));
const ElectricalCabinetPage = lazy(() => import('../pages/production/electrical-cabinet/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const CranePathDesignPage = lazy(() => import('../pages/projects/crane-path-design/page'));
const CraneOverpassDesignPage = lazy(() => import('../pages/projects/crane-overpass-design/page'));
const MetalStructuresDesignPage = lazy(() => import('../pages/projects/metal-structures-design/page'));
const CraneElectricalDesignPage = lazy(() => import('../pages/projects/crane-electrical-design/page'));
const CraneFloorControlPage = lazy(() => import('../pages/projects/crane-floor-control/page'));
const PassportDuplicatesPage = lazy(() => import('../pages/projects/passport-duplicates/page'));
const ExperiencePage = lazy(() => import('../pages/experience/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const EmploymentPage = lazy(() => import('../pages/employment/page'));
const QualityPolicyPage = lazy(() => import('../pages/quality-policy/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const CookiesPolicyPage = lazy(() => import('../pages/cookies-policy/page'));
const LegalNoticePage = lazy(() => import('../pages/legal-notice/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/crane-installation',
    element: <CraneInstallationPage />,
  },
  {
    path: '/services/crane-maintenance',
    element: <CraneMaintenancePage />,
  },
  {
    path: '/services/crane-repair',
    element: <CraneRepairPage />,
  },
  {
    path: '/services/crane-modernization',
    element: <CraneModernizationPage />,
  },
  {
    path: '/production',
    element: <ProductionPage />,
  },
  {
    path: '/production/crane-runway',
    element: <CraneRunwayPage />,
  },
  {
    path: '/production/crane-overpass',
    element: <CraneOverpassPage />,
  },
  {
    path: '/production/metal-structures',
    element: <MetalStructuresPage />,
  },
  {
    path: '/production/electrical-cabinet',
    element: <ElectricalCabinetPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/projects/crane-path-design',
    element: <CranePathDesignPage />,
  },
  {
    path: '/projects/crane-overpass-design',
    element: <CraneOverpassDesignPage />,
  },
  {
    path: '/projects/metal-structures-design',
    element: <MetalStructuresDesignPage />,
  },
  {
    path: '/projects/crane-electrical-design',
    element: <CraneElectricalDesignPage />,
  },
  {
    path: '/projects/crane-floor-control',
    element: <CraneFloorControlPage />,
  },
  {
    path: '/projects/passport-duplicates',
    element: <PassportDuplicatesPage />,
  },
  {
    path: '/experience',
    element: <ExperiencePage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/employment',
    element: <EmploymentPage />,
  },
  {
    path: '/quality-policy',
    element: <QualityPolicyPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/cookies-policy',
    element: <CookiesPolicyPage />,
  },
  {
    path: '/legal-notice',
    element: <LegalNoticePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
